import _get from 'lodash/get';

import { Google } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';
/**
 * @summary Sends Google event when clicking on pricing panel
 * @events cmp
 */
export function pricingOverviewClick(metadata, option) {
    const {
        data = {},
        state,
    } = metadata;

    const { inventoryId } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);

    const listingType = _get(inventory, 'listingType', '').toLowerCase();

    const eventResult = 'cta::price-overview';
    const cmp = 'price_ovrvw';

    Google.sendClickEvent({
        eventElement: `vdp_${listingType}`,
        eventResult,
    }, option);

    // return data for custom event
    return {
        cmp,
    };
}
